import React from 'react';
import BaseBtn from "./BaseBtn";

const BaseSubmit=({label="Submit",className="",...props})=>{
	return (
		<BaseBtn {...{...props,label,className}}   />
	)
}
export default BaseSubmit;